import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { AnalyticsProvider } from "./components";
import UpdatePrompt from "./components/update-prompt";
import { routeTree } from "./routeTree.gen";
import { initializeModals } from "./utils/modal";
import { initializePopovers } from "./utils/popover";

// Set up a Router instance
const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  // scrollRestoration: true,
  notFoundMode: "fuzzy",
});

// Register things for typesafety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// biome-ignore lint/style/noNonNullAssertion: <explanation>
const rootElement = document.getElementById("app")!;

const queryClient = new QueryClient();

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <AnalyticsProvider />
        <UpdatePrompt />
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>
  );
}

// Initialize popovers after the app mounts
initializePopovers();
initializeModals();
